module.exports = __webpack_public_path__ + "static/media/rainbowbar.1b871473.svg";